import useReveal from "../hooks/useReveal";
import { Quote } from "lucide-react";

const ITEMS = [
    {
        quote:
            "We were paying for the same surcharge three different ways. WE DELVR LOGISTICS's invoice audit found 9% of avoidable cost we'd been signing off on every month.",
        name: "Head of Supply Chain",
        company: "AU consumer goods importer (illustrative)",
        testid: "testimonial-1",
    },
    {
        quote:
            "Our forwarders gave us status. WE DELVR LOGISTICS gave us answers. The difference is who can act on what's about to go wrong before it costs us.",
        name: "Logistics Manager",
        company: "AU electronics distributor (illustrative)",
        testid: "testimonial-2",
    },
    {
        quote:
            "First independent look at our freight in five years. The procurement benchmark alone reset every tender we ran the following quarter.",
        name: "Director of Operations",
        company: "AU industrial exporter (illustrative)",
        testid: "testimonial-3",
    },
];

export default function Testimonials() {
    const [ref, visible] = useReveal();
    return (
        <section
            data-testid="testimonials-section"
            className="relative border-t border-white/5 py-20 sm:py-28"
        >
            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
                    <div className="max-w-xl">
                        <span className="section-tag">Voices · Indicative</span>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-tight">
                            What the people running AU freight tell us.
                        </h2>
                    </div>
                    <p className="text-sm text-zinc-500 max-w-md font-mono-accent uppercase tracking-[0.16em]">
                        Quotes shown are illustrative of the conversations we have with importers &amp;
                        exporters. Real customer case studies launch with the product.
                    </p>
                </div>

                <div className="grid lg:grid-cols-3 gap-5">
                    {ITEMS.map((t) => (
                        <article
                            key={t.testid}
                            data-testid={t.testid}
                            className="card-glow rounded-2xl p-7 lg:p-8 flex flex-col"
                        >
                            <Quote size={22} className="text-cyan-400 mb-5" />
                            <p className="font-display text-lg lg:text-xl text-white leading-snug tracking-tight flex-1">
                                {t.quote}
                            </p>
                            <div className="mt-7 pt-6 border-t border-white/5">
                                <div className="text-sm text-zinc-300">{t.name}</div>
                                <div className="text-xs text-zinc-500 mt-1">{t.company}</div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
